import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  COLLECT_STATUS_CONFIG,
  DEFECT_REASON_KEYS,
} from '../../../../constants';
import { CollectStatus } from '../../../../types';
import * as Styled from './StatusPanels.styles';

interface DefectPanelProps {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
}

const config = COLLECT_STATUS_CONFIG[CollectStatus.DEFECT];
const OTHER_KEY = 'OTHER';

const DefectPanel = ({ onConfirm, onCancel }: DefectPanelProps) => {
  const { t } = useTranslation();
  const [selectedKey, setSelectedKey] = useState<string>('');
  const [otherReason, setOtherReason] = useState<string>('');

  const reason =
    selectedKey === OTHER_KEY
      ? otherReason.trim()
      : selectedKey && t(`OrderPage.Collect.DefectModal.${selectedKey}`);

  return (
    <Styled.PanelContainer
      accentColor={config.color}
      accentBackground={config.background}
      accentBorder={config.border}
    >
      <div className="panel-title">
        {t('OrderPage.Collect.DefectModal.TITLE')}
      </div>
      <Styled.ReasonsGrid>
        {DEFECT_REASON_KEYS.map((key) => (
          <button
            key={key}
            type="button"
            className={`reason-button ${selectedKey === key ? 'selected' : ''}`}
            onClick={() => setSelectedKey(key)}
          >
            {t(`OrderPage.Collect.DefectModal.${key}`)}
          </button>
        ))}
      </Styled.ReasonsGrid>
      {selectedKey === OTHER_KEY && (
        <Styled.PanelInput
          value={otherReason}
          placeholder={t('OrderPage.Collect.DefectModal.OTHER_PLACEHOLDER')}
          onChange={(e) => setOtherReason(e.target.value)}
        />
      )}
      <div className="panel-actions">
        <button
          type="button"
          className="panel-button cancel"
          onClick={onCancel}
        >
          {t('OrderPage.Collect.DefectModal.CANCEL')}
        </button>
        <button
          type="button"
          className="panel-button confirm"
          style={{ background: config.color }}
          disabled={!reason}
          onClick={() => reason && onConfirm(reason)}
        >
          {t('OrderPage.Collect.DefectModal.CONFIRM')}
        </button>
      </div>
    </Styled.PanelContainer>
  );
};

export default DefectPanel;
